<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row v-if="!blnDetalle">
        <b-col>
          <div>
            <b-card header-tag="header"  title="">
              <template #header>
                <b-card-title>
                  <b-row class="titulo">
                    <b-col class="seccionTitulo">
                      <b-icon class="icono" icon="file-text"></b-icon>Detalle de
                      Planes/Convenios
                    </b-col>
                    <b-col class="seccionCodigo">
                      <div>Detalle_plan_conv</div>
                    </b-col>
                  </b-row>
                </b-card-title>
              </template>
              <b-card-body>
                <b-row>
                  <b-col>
                    <b-card
                      header="Búsqueda de Planes/Convenios"
                      header-tag="header"
                      title="Búsqueda de Planes/Convenios"
                    >
                      <b-card-text>
                        En esta sección encontrarás todos los planes y convenios
                        dentales que tenemos registrados.
                      </b-card-text>
                      <b-card-body>
                        <label>Selecciona una empresa:</label>
                        <div
                          v-if="
                            $localStorageService.can('BO_12_selec_emp') &&
                            !loaderEmpresa
                          "
                        >
                          <v-select
                            label="nombreComercial"
                            v-model="buscarEmpresa"
                            :options="lstEmpresas"
                            @input="seleccinarEmpresa($event)"
                          >
                            <span slot="no-options">No hay datos</span>
                          </v-select>
                        </div>
                        <b-col align="center" v-if="loaderEmpresa">
                          <b-spinner
                            variant="primary"
                            label="Spinning"
                          ></b-spinner>
                        </b-col>

                        <b-col align="center"> <br /><br /> </b-col>

                        <b-col align="center">
                          ¿No conoces la empresa del plan?<br />
                          <b-button v-b-modal.modal-1
                            >Buscar la Empresa por el nombre de un
                            Plan/Convenio</b-button
                          >

                          <b-modal
                            id="modal-1"
                            title="Busqueda de empresa por plan"
                            size="lg"
                            hide-footer
                          >
                            <br />
                            <label>Nombre Plan: </label>
                            <v-select
                              label="nombrePlan"
                              id="planes"
                              v-model="plan"
                              :options="listaBusquedaPlanEmpresa"
                              @search="getBuscarPlanEmpresaServicio"
                            >
                              <template #option="{ nombrePlan }">
                                <label>{{ nombrePlan }}</label>
                              </template>
                              <span slot="no-options">No hay datos...</span>
                            </v-select>
                            <br /><br />
                            <div>
                              <label>Empresa: </label>
                              <p v-if="plan != null">
                                {{ plan.nombreEmpresa }}
                              </p>
                            </div>

                            <br /><br />
                          </b-modal>
                        </b-col>
                      </b-card-body>
                    </b-card>
                    <b-row>
                      <b-col> <br /><br /> </b-col>
                    </b-row>
                    <b-card v-if="buscarEmpresa != null">
                      <b-card-body>
                        <label
                          >Información de la empresa:
                          {{ buscarEmpresa["nombreComercial"] }}</label
                        >
                        <div>
                          <b-table-simple responsive>
                            <b-thead class="columnas">
                              <b-tr>
                                <b-th>Id</b-th>
                                <b-th>Nombre</b-th>
                                <b-th>RFC</b-th>
                                <b-th>Razón social</b-th>
                                <b-th>Calle</b-th>
                                <b-th>Número</b-th>
                                <b-th>Colonia</b-th>
                                <b-th>C.P.</b-th>
                                <b-th>Pais</b-th>
                                <b-th>Estado</b-th>
                              </b-tr>
                            </b-thead>
                            <b-tbody>
                              <b-tr>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["idEmpresa"]
                                }}</b-th>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["nombreComercial"]
                                }}</b-th>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["rfc"]
                                }}</b-th>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["razonSocial"]
                                }}</b-th>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["calle"]
                                }}</b-th>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["numero"]
                                }}</b-th>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["colonia"]
                                }}</b-th>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["codigoPostal"]
                                }}</b-th>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["pais"]
                                }}</b-th>
                                <b-th class="parrafos">{{
                                  buscarEmpresa["estado"]
                                }}</b-th>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                        </div>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
                <b-row>
                  <p><br /></p>
                </b-row>
                <b-row>
                  <b-col>
                    <b-card
                      header="Resultado de la búsqueda"
                      header-tag="header"
                      title=""
                    >
                      <b-card-text>
                        Para saber si tenemos un plan o convenio selecciona una
                        empresa de la lista anterior.
                      </b-card-text>
                      <b-card-body v-if="blnTabla">
                        <b-tabs content-class="mt-3">
                          <b-tab title="ACTIVOS" active  @click="cambiarTab(1)"> 
                            <br />
                            <label>Filtrar Plan/Convenio: </label>
                            <v-select
                              label="nombrePlan"
                              id="pacientes"
                              v-model="planBuscado"
                              :options="lstPlanesConvenios"
                              @input="seleccionarPlan($event)"
                            >
                              <template #option="{ nombrePlan, codigoColor }">
                                <label :style="`color: ${codigoColor}`">{{
                                  nombrePlan
                                }}</label>
                              </template>
                              <span slot="no-options">No hay datos...</span>
                            </v-select>
                            <br /><br />

                            <b-table
                              hover
                              responsive
                              thead-tr-class="columnas"
                              class="parrafos"
                              id="tabla_planes_convenios"
                              :items="datosParaTablaPorBusqueda"
                              :fields="fields"
                              :per-page="registrosPorPagina"
                              :current-page="paginaActual"
                            >
                              <template v-slot:cell(fechaInicio)="row">
                                {{ row.item.fechaInicio | formatoFecha }}
                              </template>
                              <template v-slot:cell(fechaFin)="row">
                                {{ row.item.fechaFin | formatoFecha }}
                              </template>

                              <template v-slot:cell(detallePoblacion)="row">
                                <b-button v-b-modal="'modal-detalle-poblacion'+row.item.idPlan">
                                  <font-awesome-icon icon="eye"/>
                                </b-button>
                                <b-modal
                                    ok-title="Aceptar"
                                    cancel-title="Cerrar"
                                    size="xl"
                                    :id="'modal-detalle-poblacion'+row.item.idPlan"
                                    title="Detalle de la poblacion"
                                >
                                  <DetallePoblacionPlan :id-plan="row.item.idPlan"></DetallePoblacionPlan>
                                </b-modal>
                              </template>



                              <template v-slot:cell(fechaInicioContrato)="row">
                                {{ row.item.fechaInicioContrato | formatoFecha }}
                              </template>
                              <template v-slot:cell(fechaFinContrato)="row">
                                {{ row.item.fechaFinContrato | formatoFecha }}
                              </template>

                              <template v-slot:cell(Detalle)="row">
                                <b-button-group>
                                  <b-button
                                    v-if="
                                      $localStorageService.can('BO_12_detalle_emp')
                                    "
                                    size="sm"
                                    variant="outline-warning"
                                    v-on:click="verDetalle(row.item)"
                                    ><b-icon icon="info-circle"></b-icon
                                  ></b-button>
                                </b-button-group>
                              </template>
                              <template v-slot:cell(registroActivo)="row">
                                <div v-if="row.item.suspendido">
                                  <b-alert variant="secondary" show
                                  >Suspendido</b-alert
                                  >
                                </div>
                                <div v-else>
                                <b-alert
                                  variant="success"
                                  show
                                  v-if="row.item.registroActivo"
                                  >ACTIVO</b-alert
                                >
                                <b-alert variant="secondary" show v-else
                                  >INACTIVO</b-alert
                                >
                                </div>
                              </template>
                              <template v-slot:cell(usuarioModificacion)="row">
                                <p>{{ row.item.usuarioModificacion }}</p>
                              </template>
                              <template v-slot:cell(fechaModificacion)="row">
                                {{ row.item.fechaModificacion | formatoFecha }}
                              </template>
                            </b-table>
                            <b-pagination
                              v-if="
                                datosParaTablaPorBusqueda !== undefined &&
                                datosParaTablaPorBusqueda.length > 15
                              "
                              align="center"
                              v-model="paginaActual"
                              :total-rows="datosParaTablaPorBusqueda.length"
                              :per-page="registrosPorPagina"
                              aria-controls="tabla_planes_convenios"
                            ></b-pagination>
                            <div align="center" v-if="blnRegistros">
                              <b-alert show variant="warning"
                                >No se encontraron datos</b-alert
                              >
                            </div>
                            <div align="center" v-if="loaderPlanes">
                              <b-spinner
                                variant="primary"
                                label="Spinning"
                              ></b-spinner>
                            </div>

                          </b-tab>
                          <b-tab title="INACTIVOS"  @click="cambiarTab(2)"> 
                            <br />
                            <label>Filtrar Plan/Convenio: </label>
                            <v-select
                              label="nombrePlan"
                              id="pacientes"
                              v-model="planBuscado"
                              :options="lstPlanesConvenios"
                              @input="seleccionarPlan($event)"
                            >
                              <template #option="{ nombrePlan, codigoColor }">
                                <label :style="`color: ${codigoColor}`">{{
                                  nombrePlan
                                }}</label>
                              </template>
                              <span slot="no-options">No hay datos...</span>
                            </v-select>
                            <br /><br />

                            <b-table
                              hover
                              responsive
                              thead-tr-class="columnas"
                              class="parrafos"
                              id="tabla_planes_convenios"
                              :items="datosParaTablaPorBusqueda"
                              :fields="fields"
                              :per-page="registrosPorPagina"
                              :current-page="paginaActual"
                            >
                              <template v-slot:cell(fechaInicio)="row">
                                {{ row.item.fechaInicio | formatoFecha }}
                              </template>
                              <template v-slot:cell(fechaFin)="row">
                                {{ row.item.fechaFin | formatoFecha }}
                              </template>
                              
                              <template v-slot:cell(fechaInicioContrato)="row">
                                {{ row.item.fechaInicioContrato | formatoFecha }}
                              </template>
                              <template v-slot:cell(fechaFinContrato)="row">
                                {{ row.item.fechaFinContrato | formatoFecha }}
                              </template>

                              <template v-slot:cell(Detalle)="row">
                                <b-button-group>
                                  <b-button
                                    v-if="
                                      $localStorageService.can('BO_12_detalle_emp')
                                    "
                                    size="sm"
                                    variant="outline-warning"
                                    v-on:click="verDetalle(row.item)"
                                    ><b-icon icon="info-circle"></b-icon
                                  ></b-button>
                                </b-button-group>
                              </template>
                              <template v-slot:cell(registroActivo)="row">
                                <b-alert
                                  variant="success"
                                  show
                                  v-if="row.item.registroActivo"
                                  >ACTIVO</b-alert
                                >
                                <b-alert variant="secondary" show v-else
                                  >INACTIVO</b-alert
                                >
                              </template>
                              <template v-slot:cell(usuarioModificacion)="row">
                                <p>{{ row.item.usuarioModificacion }}</p>
                              </template>
                              <template v-slot:cell(fechaModificacion)="row">
                                {{ row.item.fechaModificacion | formatoFecha }}
                              </template>
                            </b-table>
                            <b-pagination
                              v-if="
                                datosParaTablaPorBusqueda !== undefined &&
                                datosParaTablaPorBusqueda.length > 15
                              "
                              align="center"
                              v-model="paginaActual"
                              :total-rows="datosParaTablaPorBusqueda.length"
                              :per-page="registrosPorPagina"
                              aria-controls="tabla_planes_convenios"
                            ></b-pagination>
                            <div align="center" v-if="blnRegistros">
                              <b-alert show variant="warning"
                                >No se encontraron datos</b-alert
                              >
                            </div>
                            <div align="center" v-if="loaderPlanes">
                              <b-spinner
                                variant="primary"
                                label="Spinning"
                              ></b-spinner>
                            </div>

                          </b-tab>
                      </b-tabs>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
              </b-card-body>
                <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div v-if="blnDetalle">
      <detalle
        :empresa-actual="empresaTO"
        v-on:regresar="cerrar($event)"
      ></detalle>
    </div>
  </div>
</template>

<script>
import detalle from "./detalle";
import Header from "@/components/Header";
import DetallePoblacionPlan from "./DetallePoblacionPlan";

export default {
  name: "busqueda",
  props: {
    empresaActual: null,
  },
  components: {
    DetallePoblacionPlan,
    detalle,
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fields: [
      { key: "idPlan", label: "Id", sortable: true },
      {
        key: "nombreEmpresa",
        label: "Aseguradora/Empresa/Broker",
        sortable: true,
      },
      { key: "nombreCuenta", label: "Cuenta", sortable: true },
      { key: "nombrePlan", label: "Nombre del Plan", sortable: true },
      "Detalle",
      { key: "nombreCobertura", label: "Cobertura Plan", sortable: true },
      { key: "nombreTipoPlan", label: "Tipo de plan", sortable: true },

      { key: "numeroPacientes", label: "Población plan", sortable: true },

      { key: "vigenciaSeleccionada", label: "Vigencia Seleccionada", sortable: true },
      { key: "fechaInicio", label: "Inicio de vigencia", sortable: true },
      { key: "fechaFin", label: "Fin de Vigencia", sortable: true },
      { key: "registroActivo", label: "Estatus", sortable: true },
      { key: "fechaInicioContrato", label: "Inicio de Vigencia del Contrato", sortable: true },
      { key: "fechaFinContrato", label: "Fin de Vigencia del Contrato", sortable: true },
      {
        key: "usuarioModificacion",
        label: "Usuario Modificación",
        sortable: true,
      },
      { key: "fechaModificacion", label: "Fecha Modificación", sortable: true },
      {key: "detallePoblacion", label: "Detalle de poblacion"}
    ],
    loaderEmpresa: false,
    loaderPlanes: false,
    empresaTO: null,
    blnDetalle: false,
    blnRegistros: false,
    blnTabla: false,
    buscarEmpresa: null,
    planConvenio: null,
    lstEmpresas: [],
    planesConvenios: [
      {
        idPlanConvenio: 10,
        broker: "SCHERING AMPLIO",
        nombreEmpresa: "ADMINISTRATEGICA",
        idEmpresa: 2,
        numPacientes: 0,
        vigencia: "2020-08-01 2021-08-01",
      },
      {
        idPlanConvenio: 20,
        broker: "SERADRI EMPLEADOS AFILIACION",
        nombreEmpresa: "ADRISA",
        idEmpresa: 3,
        numPacientes: 27,
        vigencia: "2020-08-01 2021-08-01",
      },
      {
        idPlanConvenio: 30,
        broker: "SERADRI EMPLEADOS RECONOCIMIENTO",
        nombreEmpresa: "ADRISA",
        idEmpresa: 3,
        numPacientes: 23,
        vigencia: "2020-08-01 2021-08-01",
      },
    ],
    lstPlanesConvenios: [],
    registrosPorPagina: 15,
    paginaActual: 1,
    datosParaTablaPorBusqueda: [],
    planBuscado: null,
    listaBusquedaPlanEmpresa: [],
    plan: null,
    lstPlanesConveniosOriginales: [],
    tabSeleccionado : 1,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerListaEmpresas();
    this.tabSeleccionado = 1;
  },
  methods: {
    verDetalle(empresaTO) {
      this.empresaTO = empresaTO;
      this.blnDetalle = true;
    },
    seleccinarEmpresa(evento) {
      if (evento != null) {
        this.blnTabla = true;
        this.blnRegistros = false;
        this.datosParaTablaPorBusqueda = [];
        this.obtenerPlanesEmpresa(evento);
      } else {
        this.lstPlanesConvenios = [];
        this.datosParaTablaPorBusqueda = [];
        this.planBuscado = null;
      }
    },
    cerrar: function () {
      this.blnDetalle = false;
    },
    obtenerListaEmpresas() {
      this.loaderEmpresa = true;
      this.$http
        .get(this.$api + "empresas/obtener")
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstEmpresas = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstEmpresas.push(item);
            });
            this.loaderEmpresa = false;
          }
        })
        .catch(function (error) {
          this.loaderEmpresa = false;
          console.error(error);
        });
    },
    obtenerPlanesEmpresa(empresa) {
      this.loaderPlanes = true;
      this.lstPlanesConvenios = [];
      const parametros = {idEmpresa: empresa.idEmpresa}
      this.$http
        .post(
          this.$api + "empresas/obtener/planesyconvenios/sinestatus", parametros
        )
        .then((response) => {
          this.loaderPlanes = false;
          if (response.data.data) {
            let resultado = response.data.data;
            resultado.forEach((item, index) => {
              item.id = index;
              this.paginaActual = 1;
              this.lstPlanesConveniosOriginales.push(item);
            });
          }
        })
        .catch(function (error) {
          this.loaderPlanes = false;
          console.error(error);
        }).finally(() => {
          this.cambiarTab(1);
        })
    },

    seleccionarPlan(plan) {
      this.datosParaTablaPorBusqueda = [];
      if (plan == null) {
        this.datosParaTablaPorBusqueda = this.lstPlanesConvenios;
      } else {
        this.lstPlanesConvenios.forEach((element) => {
          if (element.idPlan == plan.idPlan) {
            this.datosParaTablaPorBusqueda.push(element);
          }
        });
      }
    },

    getBuscarPlanEmpresaServicio(search, loading) {
      loading(true);
      clearTimeout(this.controladorTiempo);
      this.controladorTiempo = setTimeout(() => {
        const param = { nombrePlan: search }
        this.$http
          .post(
            this.$api +
              "catalogos/planempresa/obtenerpalna/activos/porletranombre",
              param
          )
          .then((response) => {
            if (response.data.data) {
              this.listaBusquedaPlanEmpresa = [];
              let resultado = response.data.data;
              resultado.forEach((item, index) => {
                item.id = index;
                this.listaBusquedaPlanEmpresa.push(item);
              });
              loading(false);
            }
          })
          .catch(function (error) {
            console.error(error);
            loading(false);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          });
        clearTimeout(this.controladorTiempo);
      }, 1000);
    },


    cambiarTab(idTab){
      var estatus = true;
      this.lstPlanesConvenios = [];
      this.datosParaTablaPorBusqueda = [];

      this.tabSeleccionado = idTab;
      if(this.tabSeleccionado == 2){
          estatus  = false;
       }  
      this.lstPlanesConveniosOriginales.forEach((elemento) => {
        if (elemento.registroActivo == estatus) {
          this.lstPlanesConvenios.push(elemento);
          this.datosParaTablaPorBusqueda.push(elemento);
        } 
      }); 
      if (this.lstPlanesConvenios.length <= 0) {
        this.blnRegistros = true;
      }

    }



  },
};
</script>

<style scoped>
</style>
